(
    function() {
        /* Desktop navigation support */
        var check_desktop = document.getElementById('main-menu__toggle');
        var desktop_menu_activation = document.getElementById('desktop-menu-activation-area');
        var opening = true;
        function on_outside_click(e) {
            if (opening) {
                opening = false;
                return;
            }
            check_desktop.checked = false;
        }
        document.addEventListener('click', on_outside_click);
        function dont_bubble(e) {
            e.stopPropagation();
        }
        function activating() {
            opening = true;
        }
        desktop_menu_activation.addEventListener('click', dont_bubble);
        desktop_menu_activation.addEventListener('click', activating);
    }
)();

(function(){
    /* Mobile navigation support */
    var state = document.getElementById('mobile-menu-toggle');
    var activator = document.getElementById('mobile-menu-activation-area');
    var mobile_menu_container = document.getElementById('mobile-main-menu-container');
    var opening = true;
    function on_outside_click(e) {
        if (opening) {
            opening = false;
            return;
        }
        state.checked = false;
    }
    document.addEventListener('click', on_outside_click);
    function dont_bubble(e) {
        e.stopPropagation();
    }
    function activating() {
        opening = true;
    }
    activator.addEventListener('click', dont_bubble);
    activator.addEventListener('click', activating);
    document.getElementById('mobile-menu-conainer').addEventListener('click', dont_bubble);
    document.getElementById('mobile-menu-close-icon').addEventListener('click', function(e){
        state.checked = false;
    });

    if (typeof SwpieDetect === "function") {
        SwpieDetect(
            mobile_menu_container,
            function(){},
            function(){},
            function(){},
            function(){
                on_outside_click();
            }
        );
    }
})();

/* Close banner script */
(function(){
    let now_ts = Math.floor(Date.now() / 1000);
    let closed_at = parseInt(window.localStorage.getItem('bar_closed'));
    if (!closed_at) closed_at = 0;
    let el_banner = document.getElementById('banner-container');

    let open_after = closed_at + (60*60*12);
    // let open_after = closed_at + 60;

    if (now_ts > open_after) {
        el_banner.style['display'] = 'block';
    }

  let close_buttons = document.querySelectorAll('.header__banner-close-icon');
  for (let i = 0; i < close_buttons.length; i++) {
  	close_buttons[i].addEventListener('click', function(e){
    	now_ts = Math.floor(Date.now() / 1000);
      	window.localStorage.setItem('bar_closed', now_ts);
      	el_banner.style['display'] = 'none';
    });
  }
    //document.getElementById('banner-close-icon').addEventListener('click', function(e){
    //    now_ts = Math.floor(Date.now() / 1000);
    //    window.localStorage.setItem('bar_closed', now_ts);
    //    el_banner.style['display'] = 'none';
    //});
})();
